import { createContext, useContext, useEffect } from 'react';

export type ComposerBannerKey = 'holiday' | 'snooze' | 'ai';

// Fixed visual stacking order, top to bottom. Holiday sits at the bottom, flush against the
// card, so its rose is never read as the note composer's amber directly beneath it.
export const BANNER_ORDER: ComposerBannerKey[] = ['snooze', 'ai', 'holiday'];

export interface ComposerBannersValue {
  setVisible: (key: ComposerBannerKey, visible: boolean) => void;
  hasAnyBanner: boolean;
  /** Whether a banner below `key` is visible — a banner only bleeds its color onto one. */
  hasBannerBelow: (key: ComposerBannerKey) => boolean;
}

export const ComposerBannersContext = createContext<ComposerBannersValue | null>(null);

export function useComposerBanners(): ComposerBannersValue {
  const context = useContext(ComposerBannersContext);
  if (!context) {
    throw new Error('useComposerBanners must be used within a ComposerBannersProvider');
  }
  return context;
}

export function useReportBannerVisible(key: ComposerBannerKey, visible: boolean): void {
  const { setVisible } = useComposerBanners();

  useEffect(() => {
    setVisible(key, visible);
    return () => setVisible(key, false);
  }, [key, setVisible, visible]);
}
